import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";
/**
 * CREATE API call using Axios
 * @returns - Save and submit Investigation api and return same object
 */

export const BNFFollowupAPI = async (params: { hasMovementSinceBNF: string, f18Note: string }, osdNumber: number) => {
  try {
    let headers = {
      "Content-Type": "application/json",
      "OSD-Module-Name": "shortages",
      "OSD-Section-Name": "followup",
      "OSD-Exception-Type": "BNF",
      "OSD-Action-Type": "submit",
      "OSD-Exception-Number": osdNumber.toString(),
    };
    const response = await axios.post(`${getUrl(ApiType.BNF_FOLLOWUP).replace(":osdNumber", osdNumber.toString())}`, params, { headers });
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.bnfFollowUpAPIError, { badRequestOrder: "errorsFirst" });
  }
};
